/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw consent for marketing communications`)
};

const es_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar el consentimiento para comunicaciones de marketing`)
};

const de_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widerruf der Zustimmung zu Marketingmitteilungen`)
};

const nl_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestemming voor marketingcommunicatie in te trekken`)
};

const fr_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer votre consentement pour les communications marketing`)
};

const it_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revocare il consenso alle comunicazioni di marketing`)
};

const pt_br2_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar consentimento para comunicações de marketing`)
};

const pt_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirar o consentimento para comunicações de marketing`)
};

const ja_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケティング通信への同意の撤回`)
};

const zh_privacy_right_6 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撤回营销通讯的同意`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_right_6 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_right_6(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_right_6", locale)
	if (locale === "en") return en_privacy_right_6(inputs)
	if (locale === "es") return es_privacy_right_6(inputs)
	if (locale === "de") return de_privacy_right_6(inputs)
	if (locale === "nl") return nl_privacy_right_6(inputs)
	if (locale === "fr") return fr_privacy_right_6(inputs)
	if (locale === "it") return it_privacy_right_6(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_right_6(inputs)
	if (locale === "pt") return pt_privacy_right_6(inputs)
	if (locale === "ja") return ja_privacy_right_6(inputs)
	return zh_privacy_right_6(inputs)
};